/**
* @prop --uic-charts-data-group-color: color of a specific data group, set it inside of the datagroups css class.
* @prop --uic-charts-line-chart-general-font-size: line chart base text font size
* @prop --uic-charts-line-chart-text-color: line chart text color (labels, tooltip etc.)
* @prop --uic-charts-line-chart-x-axis-label-font-weight: x axis label font weight
* @prop --uic-charts-line-chart-x-axis-label-font-size: x axis label font size
* @prop --uic-charts-line-chart-tick-line-color: color of tick lines
* @prop --uic-charts-line-chart-y-axis-tick-font-weight: y axis tick label font weight
* @prop --uic-charts-line-chart-y-axis-tick-font-size: y axis tick label font size
* @prop --uic-charts-line-chart-y-axis-label-font-weight: y axis label font weight
* @prop --uic-charts-line-chart-y-axis-label-font-size: x axis label font size
* @prop --uic-charts-line-chart-stroke-width: width of a data line, may be set for a specific data group inside it's css class
* @prop --uic-charts-line-chart-fade-out-opacity: opacity of dimmed lines, when another one is clicked
* @prop --uic-charts-line-chart-fade-out-stroke-width: line width of dimmed lines, when another one is clicked
* @prop --uic-charts-line-chart-fade-out-stroke-color: line color of dimmed lines, when another one is clicked
* @prop --uic-charts-line-chart-dot-fill-color: fill color of data points dots
* @prop --uic-charts-line-chart-tooltip-line-stroke-dasharray: stroke-dasharray for the vertical line below the tooltip
* @prop --uic-charts-line-chart-loading-overlay-color: color of the loading overlay
*/

.uic-line-chart {
    font-size: var(--uic-charts-line-chart-general-font-size, 0.8rem);
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    color: var(--uic-charts-line-chart-text-color, black);

    &__x-axis .tick line {
        display: none;
    }

    &__x-axis text {
        font-weight: var(
            --uic-charts-line-chart-x-axis-label-font-weight,
            bold
        );
        font-size: var(--uic-charts-line-chart-x-axis-label-font-size, 0.8rem);
    }

    &__y-axis path {
        display: none;
    }

    &__y-axis-grid-line {
        stroke: var(--uic-charts-line-chart-tick-line-color, #eee);
    }

    &__y-axis-grid-line--zero {
        stroke: var(--uic-charts-line-chart-tick-line-zero-color, #363636);
        stroke-dasharray: var(
            --uic-charts-line-chart-tick-line-zero-dash-array,
            2
        );
    }

    &__y-axis text {
        font-weight: var(
            --uic-charts-line-chart-y-axis-tick-font-weight,
            normal
        );
        font-size: var(--uic-charts-line-chart-y-axis-tick-font-size, 0.8rem);
    }

    &__y-axis-label {
        font-weight: var(
            --uic-charts-line-chart-y-axis-label-font-weight,
            normal
        );
        font-size: var(--uic-charts-line-chart-y-axis-label-font-size, 0.8rem);
    }

    &__data-group {
        stroke-width: var(--uic-charts-line-chart-stroke-width, 3px);
        stroke: var(--uic-charts-data-group-color, black);

        &.uic-line-chart__data-group--ignore {
            opacity: var(--uic-charts-line-chart-fade-out-opacity);
            stroke-width: var(
                --uic-charts-line-chart-fade-out-stroke-width,
                var(--uic-charts-line-chart-stroke-width, 3px)
            );
            stroke: var(
                --uic-charts-line-chart-fade-out-stroke-color,
                var(--uic-charts-data-group-color, black)
            );
        }
    }

    &__dots {
        fill: var(--uic-charts-line-chart-dot-fill-color, white);
    }

    &__tooltip-line {
        stroke: var(--uic-tooltip-border-color);
        stroke-dasharray: var(
            --uic-charts-line-chart-tooltip-line-stroke-dasharray,
            4
        );
        box-shadow: 0 0 6px 0 var(--uic-color-blue6);
    }

    &__tooltip-color-indicator {
        width: 1em;
        height: 1em;
        margin: 0 0.5em 0 0;
        display: inline-block;
        vertical-align: middle;
        background-color: var(--uic-charts-data-group-color, black);
    }

    &__loading_indicator {
        position: absolute;
        display: flex;
        align-items: center;
        justify-content: center;

        width: 100%;
        height: 100%;
        text-align: center;
        vertical-align: middle;

        background: var(--uic-charts-line-chart-loading-overlay-color, white);
    }

    uic-loader {
        position: absolute;
        display: flex;
        align-items: center;
        justify-content: center;

        width: max(188px, 25%);
        text-align: center;
        vertical-align: middle;
    }

    &__no-data-indicator {
        position: absolute;
        display: flex;
        align-items: center;
        justify-content: center;

        width: 100%;
        height: 100%;
    }
}
